import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import ModuleContext from '../../_contexts/ModuleContext';
import { useRoutes } from '../../../../hooks/useRoutes';

export function useCategoryLinkBuilder() {
  const { subjectSlug, methodSlug } = useParams();
  const { buildAbsolutePath } = useRoutes();

  const { module } = useContext(ModuleContext);

  /**
   * Builds the absolute path for the category detail in the virtual exercise module using current route parameters.
   * @returns The category link or an empy string if required parameters are missing
   */
  function buildCategoryLink(categoryId: string) {
    if (!subjectSlug || !methodSlug || !module) return '';

    return buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.VEM', 'MATERIAL.VEM.CATEGORY_DETAIL'], {
      subjectSlug: subjectSlug,
      methodSlug: methodSlug,
      moduleSlug: module.slug,
      selectedCategoryId: categoryId,
    });
  }

  return {
    buildCategoryLink,
  };
}
